/**
 * Higienização da pergunta antes de gravar o feedback.
 *
 * O que interessa na pergunta é o VOCABULÁRIO — como a pessoa chama as coisas —,
 * nunca o dado que ela colou junto. Alguém que digita "por que a cobrança do CPF
 * 123.456.789-00 sumiu" está ensinando a palavra "sumiu", não o CPF.
 *
 * Roda no cliente, antes de sair do aparelho.
 */

const PADROES: Array<{ re: RegExp; marcador: string }> = [
  { re: /\b\d{3}\.?\d{3}\.?\d{3}-?\d{2}\b/g, marcador: "[cpf]" },
  { re: /\b\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}\b/g, marcador: "[cnpj]" },
  { re: /\b[\w.+-]+@[\w-]+\.[\w.]{2,}\b/g, marcador: "[email]" },
  { re: /\(?\d{2}\)?\s?9?\d{4}[-\s]?\d{4}\b/g, marcador: "[telefone]" },
  { re: /\b\d{5}-?\d{3}\b/g, marcador: "[cep]" },
  // Valores em reais: o número exato não ensina nada sobre vocabulário.
  { re: /R\$\s?[\d.,]+/gi, marcador: "[valor]" },
];

/** Tamanho máximo aceito pela coluna. */
const LIMITE = 500;

export function sanitizeQuestion(pergunta: string): string {
  let limpo = pergunta.trim();
  for (const { re, marcador } of PADROES) limpo = limpo.replace(re, marcador);
  // Sequências longas de dígitos que escaparam dos padrões acima
  limpo = limpo.replace(/\b\d{6,}\b/g, "[numero]");
  return limpo.slice(0, LIMITE);
}
